import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { RendererProvider, RendererContext } from 'react-fela';
import getStyleRenderer from './getStyleRenderer.js';
var clientRenderer = getStyleRenderer();
export default function StyleProvider(_ref) {
  var _ref$renderer = _ref.renderer,
    renderer = _ref$renderer === void 0 ? clientRenderer : _ref$renderer,
    children = _ref.children;
  var contextRenderer = useContext(RendererContext);
  if (contextRenderer) {
    return children;
  }
  return /*#__PURE__*/React.createElement(RendererProvider, {
    renderer: renderer
  }, children);
}
StyleProvider.propTypes = {
  renderer: PropTypes.object,
  children: PropTypes.node
};